import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import CompleteIcon from '@/assets/img/icon/complete.svg';
import ArrowRightIcon from '@/components/Icon/ArrowRightIcon';
import { MYPAGE_MENU_BASIC } from '@/constants/mypage';
import { useModalStore } from '@/store/modalStore';
import { useToastStore } from '@/store/toastStore';

import * as S from './style';

const AccountExit = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { openToast } = useToastStore();
	const { showModal } = useModalStore();
	const showToast = () => {
		openToast({
			content: 'mypage.accountExit.toast.content',
			subContent: 'common.societyName',
			showTime: 3000,
		});
		showModal('mypage.accountExit.modal.message');
	};
	return (
		<S.FormContainer>
			<S.Container>
				<S.ImgBox>
					<img src={CompleteIcon} alt={t('mypage.accountExit.alt')} />
				</S.ImgBox>
				<S.ContentBox>
					<S.Title>{t('mypage.accountExit.title')}</S.Title>
					<S.SubTitle>
						{t('mypage.accountExit.descriptionLine1')}
						<br />
						{t('mypage.accountExit.descriptionLine2')}
					</S.SubTitle>
				</S.ContentBox>
			</S.Container>
			<S.ButtonBox>
				<S.NextButton
					type="button"
					onClick={() => {
						navigate('/mypage', { state: { menu: MYPAGE_MENU_BASIC } });
					}}
				>
					{t('common.actions.cancel')}
				</S.NextButton>
				<div className="button_wrap">
					<S.SecessionButton onClick={showToast}>
						{t('mypage.accountExit.confirmButton')} <ArrowRightIcon width="16" height="16" iconColor="#495057" />
					</S.SecessionButton>
				</div>
			</S.ButtonBox>
		</S.FormContainer>
	);
};

export default AccountExit;
